module.exports = __webpack_public_path__ + "media/images/icons/line-68d553092bce92a7c09d817df3542685.svg";